export const phoneNumberRegex = /^(\+?\d{0,4})?\s?-?\s?(\(?\d{3}\)?)\s?-?\s?(\(?\d{3}\)?)\s?-?\s?(\(?\d{4}\)?)?$/;

export const strongPasswordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*?[\u00A3#?!@$%^"&*-.,])(?=.{8,20})/;

export const passwordRegex = /^(?=.*[a-zA-Z])(?=.*[0-9])(?=.{8,20})/;